import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
  TextField,
} from "@mui/material"
import React from "react"
import { useFormik } from 'formik';
import { useTranslation } from "react-i18next"
import { ReactComponent as WarningAlert } from "../assets/images/warning-alert.svg"
import CloseIcon from "../assets/images/plus-circle-fill.svg"
import * as yup from 'yup';

const WarningConfirmDialog = (props) => {
  const { t } = useTranslation();
  const handleClose = () => {
    props.setValue(false)
    formik.resetForm()
  };



  const handleSubmit = () => {
    formik.submitForm()
  }

  const validationSchemaRemark = yup.object({
    remark: yup.string().required(t("label.pleaseFillOutThisField"))
  });

  let config = {
    initialValues: {
      remark: "",
    },
    enableReinitialize: true,
    //validationSchema: validationSchemaRemark,
    onSubmit: (values) => {
      props.doConfirm(formik.values)
      formik.resetForm()
    },
  }

  if (props.haveComment) config.validationSchema = validationSchemaRemark

  const formik = useFormik(config);

  return (
    <React.Fragment>
      <Dialog
        onBackdropClick={() => { return false }}
        open={props.open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="form-add-dialog-title" fontSize="1.3rem">
          {props.title}
          <Box sx={{ position: "absolute", right: 0, margin: "20px 18px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
          <Divider sx={{ marginTop: "10px" }} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column', textAlign: 'center' }}>
            <WarningAlert />
            <Typography mt={3} fontSize={16} color={'#404349'}>{props.text}</Typography>
            {props.text2 &&
              <Typography fontSize={16}>{props.text2}</Typography>
            }

            {props.haveComment &&
              <TextField
                multiline
                rows={4}
                margin="dense"
                id="remark"
                value={formik.values.remark}
                onChange={formik.handleChange}
                fullWidth
                size="large"
                placeholder={t("label.fillInTheComments")}
                helperText={formik.touched.remark && formik.errors.remark}
                error={Boolean(formik.touched.remark && formik.errors.remark)}
              />
            }

          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <Button onClick={handleClose} size="medium" variant="outlined" sx={{ width: '150px', marginRight: "10px", textTransform: "none" }} color="black">{t('label.notSure')}</Button>
          <Button onClick={handleSubmit} size="medium" variant="contained" sx={{ width: '150px', color: "#fff!important", textTransform: "none" }} color="warning">{t('label.ofCourse')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}
export default WarningConfirmDialog
